var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _path15, _ellipse4, _ellipse5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 958.55 350",
    style: {
      enableBackground: "new 0 0 958.55 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.2;fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{opacity:0.2;fill:url(#SVGID_4_);}\n\t.st4{opacity:0.5;fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{opacity:0.8;fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{opacity:0.15;fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{opacity:0.2;fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:#070807;}\n\t.st15{opacity:0.5;fill:url(#SVGID_15_);}\n\t.st16{fill:url(#SVGID_16_);}\n\t.st17{fill:#919376;}\n\t.st18{opacity:0.2;fill:url(#SVGID_17_);}\n\t.st19{fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{opacity:0.4;}\n\t.st22{fill:url(#SVGID_20_);}\n\t.st23{fill:url(#SVGID_21_);}\n\t.st24{fill:url(#SVGID_22_);}\n\t.st25{fill:url(#SVGID_23_);}\n\t.st26{fill:url(#SVGID_24_);}\n\t.st27{fill:url(#SVGID_25_);}\n\t.st28{opacity:0.2;fill:#FFFFFF;}\n\t.st29{fill:url(#SVGID_26_);}\n\t.st30{fill:url(#SVGID_27_);}\n\t.st31{opacity:0.1;fill:#FFFFFF;}\n\t.st32{opacity:0.2;fill:url(#SVGID_28_);}\n\t.st33{fill:url(#SVGID_29_);}\n\t.st34{opacity:0.1;fill:url(#SVGID_30_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.2268,
    y1: 347.1343,
    x2: 492.0701,
    y2: 39.046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    style: {
      stopColor: "#F7F0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ECD8E3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M954.64,126.57c0,0-0.02,0.02-0.03,0.05c-0.43,0.59-4.29,5.39-13.03,4.93c-9.3-0.48,10.11,8.02,10.4,12.58 c0.45,7.16,1.31,15.78-1.19,27.67c-1.02,4.86-2.11,10.35-3.4,16.35c-3.77,17.44-9.33,39.11-20.43,61.49 c-12.93,26.11-33.36,53.18-67.25,75.58c-72.92,48.2-215.16,14.98-268.2-6.72c-53.02-21.69-133.79-105.46-162.11-105.46 c-24.46,0-198.88-23.35-246.16-29.74c-5.84-0.78-11.74-0.28-17.32,1.49c-1.78,0.55-3.54,1.24-5.25,2.06 c-2.97,1.42-6.46,3.09-10.37,4.96c-3.98,1.9-8.37,3.99-13.05,6.24c-34.15,16.37-83.68,40.34-98.98,48.76 c-24.11,13.26-26.53-6.03-26.53-6.03c-0.95-3.44-1.83-6.91-2.64-10.4C-12.2,139.91,8.68,37.73,23.19,40.07 c9.83,1.57,60.84,24.46,97.23,41.32c6.69,3.11,12.89,6,18.25,8.54c10.16,4.79,17.32,8.24,19.06,9.19c0.88,0.48,1.64,0.93,2.32,1.38 v0.02c7.69,5.08,4.17,8.54,23,11.87c20.48,3.61,101.47-18.54,101.47-18.54c85.19,0.38,148.84-59.16,148.84-59.16 C475.3,26.1,536.05,0.47,625.99,0.01c97.99-0.52,219.75,32.35,219.75,32.35c21.76,5.84,57.6,27.29,82.96,47.36 c15.69,12.43,27.39,24.33,29.23,31.71C959.76,118.72,957.2,121.18,954.64,126.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.6345,
    y1: 327.8161,
    x2: 536.5768,
    y2: 27.5769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#6C7984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M950.79,171.8c-2.14,10.13-4.55,23.09-8.59,37.57c-3.53,12.58-8.31,26.29-15.24,40.27 c-38.06-9.49-35.17-55.75-88.73-13.81c-34.98,27.39-59.52,25.68-95.06,5.18c-43.9-25.34-124.8,36.36-146.58,0.24 c-21.76-36.1-22.17-55.46-88.25-52.42c-24.2,1.11-59.33-1.28-87.16-24.35c-12.86-10.66-23.63-13.33-64.78,1.71 c-48.84,17.85-163.64-1.73-185.19,1.71c-12.2,1.95-20.91,4.93-27.19,7.57c-0.86-3.01-1.52-5.95-2.02-8.81 c-0.66-3.72-1.02-7.33-1.16-10.78c-0.03-0.73-0.05-1.43-0.05-2.14c85.36,9.71,322.92-33.75,363.62-56.86 c14.81-8.42,66.23-47.58,95.71-54.03c37.24-8.16,58.64,12.67,63.34,47.56c3.8,28.22,31.61,50.55,67.54,48.17 c28-1.87,19.06-34.45,51.14-38.25c25.16-2.97,49.27,10.96,72.54,25.63c11.55,7.26,22.9,14.71,34.06,20.34 c21.69,10.94,42.71,15.07,63.22-2.18C952.43,151.28,953.3,159.91,950.79,171.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.6281,
    y1: -125.9385,
    x2: 544.5931,
    y2: 74.4608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#6C7984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M954.64,126.57c0,0-0.02,0.02-0.03,0.05c-0.02,0.03-0.07,0.07-0.1,0.14c-0.05,0.05-0.1,0.12-0.17,0.19 c-0.95,1.11-4.11,4.2-10.25,4.58c-0.78,0.05-1.62,0.07-2.51,0.02c-9.3-0.48,10.11,8.02,10.4,12.58 c-20.51,17.25-41.53,13.12-63.22,2.18c-11.16-5.63-22.52-13.08-34.06-20.34c-23.26-14.67-47.37-28.6-72.54-25.63 c-32.08,3.8-23.14,36.38-51.14,38.25c-15.12,1-28.81-2.37-39.87-8.73c-15.23-8.73-25.48-23.09-27.67-39.44 c-4.7-34.89-26.1-55.72-63.34-47.56c-29.48,6.45-80.9,45.61-95.71,54.03c-10.15,5.76-32.53,12.77-61.73,19.93 c-31.89,7.81-71.91,15.78-113.05,22.38c-60.56,9.76-123.49,16.64-166.33,15.87c-8.31-0.14-15.87-0.57-22.5-1.33 c-0.02-1.43,0-2.85,0.05-4.23c0.16-4.17,0.66-8.12,1.38-11.84c0.43-2.32,0.97-4.55,1.57-6.67c1-3.53,2.18-6.78,3.46-9.75 c1.31-3.13,2.75-5.95,4.13-8.4h0.02c4.46-7.92,8.64-12.31,8.64-12.31c7.69,5.08,4.17,8.54,23,11.87 c20.48,3.61,101.47-18.54,101.47-18.54c85.19,0.38,148.84-59.16,148.84-59.16c8.97-1.85,18.82-4.46,29.62-7.45 c39.65-10.96,92.31-26.88,163-27.24c97.99-0.52,219.75,32.35,219.75,32.35c2.25,0.6,4.63,1.37,7.16,2.3 c12.36,4.48,27.69,12.55,42.78,21.93c11.89,7.4,23.61,15.62,33.65,23.63c1.43,1.14,2.85,2.28,4.22,3.42 c0.92,0.76,1.8,1.5,2.68,2.26c0.6,0.52,1.21,1.04,1.8,1.54c1.04,0.92,2.04,1.81,3.01,2.7c0.86,0.79,1.71,1.57,2.52,2.35 c0.38,0.36,0.74,0.71,1.11,1.07c0.07,0.05,0.12,0.12,0.19,0.17c0.29,0.29,0.59,0.59,0.88,0.88c0.35,0.35,0.69,0.69,1.04,1.04 c0.33,0.35,0.67,0.69,0.99,1.02c3.59,3.73,6.39,7.21,8.17,10.21c0.16,0.26,0.31,0.52,0.43,0.78c0.6,1.09,1.07,2.11,1.37,3.08 c0.09,0.22,0.16,0.47,0.21,0.69C959.76,118.72,957.2,121.18,954.64,126.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.3251,
    y1: 119.1554,
    x2: 579.9507,
    y2: 0.377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M691.15,129.85c-15.23-8.73-25.48-23.09-27.67-39.44c-4.7-34.89-26.1-55.72-63.34-47.56 c-29.48,6.45-80.9,45.61-95.71,54.03c-10.15,5.76-32.53,12.77-61.73,19.93c0.17-0.37,0.24-0.81,0.5-1.11 c18.78-21.84,41.59-39.75,72.07-56.75c41.54-23.17,81.12-34.86,106.94-35.99c57.34-2.51,98.2,40.58,100.43,70.91 C724.42,118.01,727.82,138.73,691.15,129.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 835.9625,
    y1: 95.1204,
    x2: 885.5204,
    y2: 30.2734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M824.49,59.16c-1.04-4.29-0.42-9.53,7.88-11.41c25.4-5.76,37.21,10.51,46.14,28.02 c12,23.54-6.29,21.22-12.38,18.95C840.37,85.13,826.54,67.64,824.49,59.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 920.1538,
    y1: 203.7177,
    x2: 920.4235,
    y2: 167.5788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#D3C6C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8BFC9"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M950.79,171.8c-2.14,10.13-4.55,23.09-8.59,37.57c-11.96,2.74-41.2-6.52-49.08-29.54 c-3.89-11.39-5.1-22.76-4.36-33.53c21.69,10.94,42.71,15.07,63.22-2.18C952.43,151.28,953.3,159.91,950.79,171.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1022.5732,
    y1: 171.1399,
    x2: 879.6783,
    y2: 98.2915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M954.64,126.57c0,0-0.02,0.02-0.03,0.05c-0.02,0.03-0.07,0.07-0.1,0.14c-0.05,0.05-0.1,0.12-0.17,0.19 c-0.67,0.67-2.33,2.21-4.99,3.32c-1.45,0.62-3.2,1.11-5.25,1.26c-0.78,0.05-1.62,0.07-2.51,0.02c-9.3-0.48,10.11,8.02,10.4,12.58 c-14.1,11.86-28.45,13.62-43.09,9.99c-6.65-1.64-13.36-4.39-20.13-7.81c2.28-33.3,23.18-60.89,40.56-66.09 c1.43,1.14,2.85,2.28,4.22,3.42c0.92,0.76,1.8,1.5,2.68,2.26c0.6,0.52,1.21,1.04,1.8,1.54c1.04,0.92,2.04,1.81,3.01,2.7 c0.86,0.79,1.71,1.57,2.52,2.35c0.38,0.36,0.74,0.71,1.11,1.07c0.07,0.05,0.12,0.12,0.19,0.17c0.29,0.29,0.59,0.59,0.88,0.88 c0.35,0.35,0.69,0.69,1.04,1.04c0.33,0.35,0.67,0.69,0.99,1.02c3.59,3.73,6.39,7.21,8.17,10.21c0.16,0.26,0.31,0.52,0.43,0.78 c0.6,1.09,1.07,2.11,1.37,3.08c0.09,0.22,0.16,0.47,0.21,0.69C959.76,118.72,957.2,121.18,954.64,126.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.3994,
    y1: -95.1596,
    x2: 349.9475,
    y2: 58.9122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#A79A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F3515"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M433.37,34.69c0,0-63.65,59.54-148.84,59.16c-1.97-2.7-4.93-6.74-8.4-11.61 c-17.14-24.2-46.87-68.89-32.06-70.91c14.28-1.94,50.5,9.56,90.18,17.21c9.78,1.9,19.77,3.56,29.71,4.74 c4.74,0.55,9.04,1.07,12.94,1.52C407.14,38.25,414.98,38.46,433.37,34.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.7102,
    y1: 86.8374,
    x2: 315.3766,
    y2: -11.5334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M433.37,34.69c0,0-63.65,59.54-148.84,59.16c-1.97-2.7-4.93-6.74-8.4-11.61c26.6-4.74,41.76-32.8,58.12-53.7 c9.78,1.9,19.77,3.56,29.71,4.74c4.74,0.55,9.04,1.07,12.94,1.52C407.14,38.25,414.98,38.46,433.37,34.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.6982,
    y1: 283.8118,
    x2: 349.6613,
    y2: 217.2822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#E6D4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ECD8E3"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M431.28,213.16c0,0-5.74,6.46-17.16,14.64c-23.02,16.54-69.18,40.17-138,32.09 c-9.28-1.09-15.28-10.34-12.58-19.27c4.44-14.73,12.39-35.08,24.21-43.52l30.73,3.44L431.28,213.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.332,
    y1: 128.0609,
    x2: 681.2488,
    y2: 150.7976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#6C7984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M738.06,132.03c-7.85-25.96-66.06-19.65-66.06-19.65s12.85,51.8-7.05,84.37c0,0,46.2-18.57,57.68-28.38 C740.42,153.19,741.38,143,738.06,132.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.5128,
    y1: 50.5237,
    x2: 557.7773,
    y2: 132.2863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M561.82,75.65c-4.75,5.55-14.56-4.3-14.89,6.62s0.99,14.56-3.64,17.21c-4.63,2.65-13.57,12.73-4.3,24.56 c9.26,11.83,32.09,14.39,34.08,22.71c1.99,8.32,18.68,7.28,27.21,2.67c8.53-4.61,30.36-32.07,41.28-39.68 c10.92-7.61,19.52-23.18,9.26-34.91c-10.26-11.74-24.15-9.75-31.76-13.39s-33.52-12.99-32.76-4.3c0.64,7.3-0.33,12.24-5.96,10.26 C574.72,65.39,569.79,66.31,561.82,75.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.3619,
    y1: 67.3904,
    x2: 563.9431,
    y2: 146.1374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#6C7984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M619.28,131.47c-7.62,8.11-14.9,15.71-19.01,17.94c-8.52,4.61-25.22,5.65-27.2-2.66 c-1.99-8.33-24.82-10.89-34.08-22.71c-9.26-11.84-0.33-21.91,4.3-24.56c4.63-2.66,3.3-6.29,3.63-17.21 c0.22-7.36,4.75-5.29,9.14-4.86c-1.85,5.72-0.88,11.41,6.53,15.35c21,11.15,31.85,0.73,34.53,24.54 C598.71,131.43,608.08,134.66,619.28,131.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -57.4146,
    y1: 104.546,
    x2: 68.1006,
    y2: 165.0623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#6C7984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.06,100.51v0.02c0,0-4.18,4.39-8.64,12.31h-0.02c-1.38,2.45-2.82,5.27-4.13,8.4 c-1.28,2.97-2.45,6.22-3.46,9.75c-0.6,2.13-1.14,4.36-1.57,6.67c-0.73,3.72-1.23,7.67-1.38,11.84c-0.09,2.07-0.09,4.2,0,6.39 c0.14,3.46,0.5,7.07,1.16,10.78c0.59,3.34,1.38,6.76,2.44,10.28c1.45,4.79,3.35,9.75,5.84,14.85c-0.52,0.24-1.04,0.48-1.57,0.74 c-0.79,0.38-1.59,0.76-2.42,1.16c-0.6,0.29-1.23,0.59-1.85,0.88c-0.64,0.31-1.28,0.6-1.92,0.92c-0.64,0.31-1.3,0.62-1.95,0.93 c-0.66,0.31-1.31,0.64-1.99,0.95c-5.41,2.61-11.23,5.41-17.27,8.31c-1.35,0.64-2.68,1.28-4.04,1.94c-1.61,0.78-3.25,1.57-4.87,2.35 c-1.11,0.54-2.21,1.07-3.34,1.61c-2.06,1-4.13,2-6.2,3.01c-2.07,1.02-4.15,2.02-6.22,3.02c-9.64,4.68-19.15,9.33-27.72,13.55 c-1.14,0.57-2.28,1.14-3.39,1.69c-1.33,0.66-2.63,1.3-3.91,1.94c-2.21,1.11-4.34,2.16-6.36,3.18c-1.05,0.54-2.07,1.04-3.04,1.54 c-0.81,0.41-1.61,0.81-2.39,1.21c-1.69,0.86-3.27,1.68-4.74,2.44c-0.45,0.22-0.9,0.47-1.31,0.69c-2.16,1.11-4.01,2.11-5.53,2.94 c-24.11,13.26-26.53-6.03-26.53-6.03c-0.95-3.44-1.83-6.91-2.64-10.4c-1.43-6.05-2.66-12.15-3.72-18.29 c-1.68-9.61-2.9-19.25-3.77-28.81c-0.69-7.71-1.16-15.36-1.38-22.88c-0.29-8.87-0.29-17.56-0.03-25.94 c0.29-9.04,0.85-17.72,1.64-25.91c0.86-8.95,2-17.32,3.34-24.92c2-11.44,4.42-21.14,7.03-28.45c3.58-10.08,7.47-15.66,10.99-15.09 c9.83,1.57,60.84,24.46,97.23,41.32c19.39,8.99,34.64,16.28,37.31,17.73C158.62,99.61,159.38,100.06,160.06,100.51z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 517.77,
    cy: 120.11,
    rx: 13.61,
    ry: 18.82
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3037 -0.9528 0.9528 0.3037 400.009 851.0646)",
    className: "st14",
    cx: 782.28,
    cy: 151.86,
    rx: 19.6,
    ry: 14.18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 144.2475 571.8136)",
    className: "st14",
    cx: 762.36,
    cy: 111.78,
    rx: 19.6,
    ry: 14.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.5922,
    y1: 94.3048,
    x2: 845.1938,
    y2: 114.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M839.47,101.18c-6.33,1.59-13.24-0.76-15.43-9.49c-1.24-4.91-0.73-9.7,1.07-13.24 c1.09-2.13,2.64-3.82,4.56-4.79c0.59-0.29,1.19-0.54,1.83-0.69c4.63-1.16,9.57,1.64,12.75,6.65c0.95,1.5,1.75,3.2,2.32,5.05 c0.14,0.41,0.26,0.83,0.36,1.24C849.13,94.67,845.78,99.59,839.47,101.18z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9528 -0.3037 0.3037 0.9528 -6.5482 255.3889)",
    className: "st14",
    cx: 817.78,
    cy: 148.75,
    rx: 8.67,
    ry: 8.35
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 240.8324 728.7363)",
    className: "st14",
    cx: 751.52,
    cy: 155.8,
    rx: 5.17,
    ry: 3.36
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M453.68,136.39c2.05,8.26-2.23,16.44-9.56,18.26c-7.34,1.82-14.95-3.39-17-11.66 c-2.05-8.26,3.37-13.28,10.71-15.11C445.15,126.06,451.63,128.13,453.68,136.39z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M478.87,126.52c1.44,5.81-1.57,11.56-6.73,12.84c-5.16,1.28-10.51-2.39-11.96-8.2 c-1.44-5.81,2.37-9.34,7.53-10.62C472.88,119.26,477.43,120.71,478.87,126.52z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M500.57,106.24c-0.43,7.72-5.09,13.74-10.4,13.44c-5.31-0.3-9.26-6.8-8.82-14.53s5.16-10.7,10.47-10.4 C497.12,95.05,501,98.51,500.57,106.24z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M382.89,142.14c1.44,5.81-1.57,11.56-6.73,12.84c-5.16,1.28-10.51-2.39-11.96-8.2 c-1.44-5.81,2.37-9.34,7.53-10.62C376.89,134.88,381.44,136.33,382.89,142.14z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M302.76,159.4c-1.55,4.5-4.97,7.4-7.63,6.48c-2.66-0.92-3.57-5.31-2.02-9.81c1.55-4.5,4.48-5.6,7.14-4.68 C302.92,152.32,304.31,154.9,302.76,159.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M253.86,152.14c1.15,4.62-0.14,8.91-2.87,9.59c-2.73,0.68-5.88-2.51-7.03-7.13s0.71-7.13,3.45-7.81 C250.14,146.11,252.72,147.53,253.86,152.14z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M515.96,160.69c2.38,9.58-2.58,19.06-11.09,21.18s-17.34-3.94-19.72-13.52c-2.38-9.58,3.91-15.4,12.42-17.52 S513.58,151.11,515.96,160.69z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M412.43,139.15c1.28,5.13,0.47,9.74-1.79,10.3c-2.26,0.56-5.13-3.14-6.41-8.26 c-1.27-5.13,0.13-7.76,2.39-8.32C408.88,132.31,411.15,134.03,412.43,139.15z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M358.84,152.75c0.65,2.59-0.67,5.15-2.93,5.72c-2.26,0.56-4.62-1.08-5.27-3.68 c-0.65-2.59,1.02-4.16,3.29-4.73C356.19,149.5,358.19,150.16,358.84,152.75z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M426.62,164.09c1.98-3.51,1.41-7.58-1.28-9.1c-2.69-1.52-6.47,0.1-8.45,3.61c-1.98,3.51-0.51,6.27,2.18,7.79 C421.76,167.9,424.64,167.59,426.62,164.09z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M403.24,158.32c-1.46,3.88-5.25,6.04-8.46,4.83c-3.21-1.21-4.62-5.33-3.16-9.21 c1.46-3.88,4.82-4.47,8.03-3.26S404.7,154.44,403.24,158.32z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M474.1,159.16c1.9,7.64,0.01,14.69-4.23,15.75c-4.24,1.05-9.21-4.29-11.11-11.93 c-1.9-7.64,0.93-11.75,5.17-12.8C468.17,149.12,472.2,151.52,474.1,159.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.4738,
    y1: 71.2862,
    x2: 834.7685,
    y2: 88.3133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    style: {
      stopColor: "#D0C29B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4B982"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M846.57,84.68c-0.69,1.31-1.62,2.45-2.73,3.4c-1.99,1.68-4.55,2.7-7.36,2.7c-6.29,0-11.41-5.12-11.41-11.41 c0-0.31,0.02-0.62,0.03-0.92c0.74-1.47,1.73-2.73,2.89-3.66c0.14-0.12,0.28-0.22,0.41-0.31c0.4-0.33,0.83-0.59,1.26-0.81 c0.59-0.29,1.19-0.54,1.83-0.69c0.8-0.21,1.61-0.28,2.4-0.24c3.87,0.12,7.73,2.75,10.35,6.9c0.36,0.57,0.69,1.16,0.99,1.78 c0.22,0.41,0.41,0.83,0.59,1.28C846.12,83.33,846.35,83.98,846.57,84.68z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M846.57,84.68c-0.69,1.31-1.62,2.45-2.73,3.4c-2.07-0.16-4.13-0.71-6.1-1.66c-4.99-2.42-8.3-6.91-9.33-11.94 c0.4-0.33,0.83-0.59,1.26-0.81c0.59-0.29,1.19-0.54,1.83-0.69c0.8-0.21,1.61-0.28,2.4-0.24c3.87,0.12,7.73,2.75,10.35,6.9 c0.36,0.57,0.69,1.16,0.99,1.78c0.22,0.41,0.41,0.83,0.59,1.28C846.12,83.33,846.35,83.98,846.57,84.68z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M845.24,81.41c0.22,0.41,0.41,0.83,0.59,1.28c-1.75-0.03-3.51-0.43-5.18-1.24c-3.63-1.75-6.01-5.03-6.74-8.71 c3.87,0.12,7.73,2.75,10.35,6.9C844.62,80.2,844.95,80.79,845.24,81.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.7371,
    y1: 193.1019,
    x2: 336.1846,
    y2: 255.7182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#D3C6C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8BFC9"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M431.28,213.16c0,0-5.74,6.46-17.16,14.64c-75.22,13.43-96.02-26.82-96.02-26.82s0.14-0.16,0.38-0.43 L431.28,213.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.6173,
    y1: -6.784,
    x2: 375.0089,
    y2: 96.2976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#CAD2C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B8D5CC"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M427.79,39.48c0.01,0,0.03,0.01,0.04,0.01c2.59,0.79,3.88,3.7,2.85,6.2L430,47.34 c-3.27,7.9-6.62,12.89-9.11,16.11c1.62,2.04,3.18,4.93,3.42,8.73c0.47,7.14-3.8,14.9-14.26,25.91 c-17.73,18.67-53.99,26.68-63.08,26.68c-1.33,0-2.44-0.14-3.49-0.43c-2.87-0.83-5.05-2.51-6.52-5.01 c-0.71,0.05-1.45,0.07-2.23,0.07c-4.15,0-18.1-0.71-22.69-9.8c-2.21-4.36-1.62-9.38,1.61-13.79c1.3-1.76,2.4-3.32,3.34-4.67 C371.65,81.89,413.27,51.37,427.79,39.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.2279,
    y1: 107.0483,
    x2: 354.5971,
    y2: 20.1925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M403.78,92.14c-16.56,17.42-54.11,24.97-57.92,23.89c-3.8-1.09,0-6.96-7.05-5.6 c-7.07,1.35-24.18-1.37-18.2-9.51c5.98-8.16,8.17-12.13,8.17-12.13l-0.26,0.05l-14.12,2.73c-0.07,0.02-0.14,0.02-0.22,0.02 c0.97-13.38,10.51-17.94,18.16-17.7c9.64,0.31,20.13-5.57,28.86-15.68c12.01-13.91,59.68-14.26,60.8-14.17 c-8.04,19.44-15.87,17.97-9.9,22.81C416.97,70.81,419.15,75.96,403.78,92.14z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M314.41,91.57l-0.22,0.03v-0.02C314.27,91.59,314.34,91.59,314.41,91.57z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.6164,
    y1: 75.5125,
    x2: 17.5403,
    y2: 76.9212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M160.06,100.51v0.02l-7.54,10.72c-0.65,0.93-1.86,1.28-2.91,0.85L12.2,55.16 c3.58-10.08,7.47-15.66,10.99-15.09c9.83,1.57,60.84,24.46,97.23,41.32c19.39,8.99,34.64,16.28,37.31,17.73 C158.62,99.61,159.38,100.06,160.06,100.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.522,
    y1: 183.3765,
    x2: 18.7096,
    y2: 184.7822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M140,167.34L5.38,212.07c-1.68-9.61-2.9-19.25-3.77-28.81l136.91-26.92c1.24-0.24,2.38,0.66,2.47,1.92 c0.14,2.06,0.37,4.16,0.69,6.31C141.85,165.78,141.16,166.95,140,167.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.0031,
    y1: 145.7975,
    x2: 18.2749,
    y2: 147.2023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M141.84,139.86c-0.42,2.52-0.73,5.15-0.9,7.87c-0.06,1.01-0.84,1.82-1.84,1.9L0.22,160.38 c-0.29-8.87-0.29-17.56-0.03-25.94L140,137.6C141.17,137.62,142.03,138.69,141.84,139.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.3227,
    y1: 106.4032,
    x2: 17.8132,
    y2: 107.8055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M146.5,123.08c-0.8,2.01-1.56,4.14-2.24,6.39c-0.26,0.86-1.1,1.4-1.99,1.26L1.83,108.53 c0.86-8.95,2-17.32,3.34-24.92l140.15,37.11C146.35,120.99,146.9,122.09,146.5,123.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1626,
    y1: 213.8922,
    x2: 19.0864,
    y2: 215.3009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M150.29,191.8c-0.52,0.24-1.04,0.48-1.57,0.74c-0.79,0.38-1.59,0.76-2.42,1.16 c-0.6,0.29-1.23,0.59-1.85,0.88c-0.64,0.31-1.28,0.6-1.92,0.92c-0.64,0.31-1.3,0.62-1.95,0.93c-0.66,0.31-1.31,0.64-1.99,0.95 c-5.41,2.61-11.23,5.41-17.27,8.31c-1.33,0.62-2.68,1.28-4.04,1.94c-1.61,0.78-3.25,1.57-4.87,2.35 c-1.11,0.54-2.23,1.07-3.34,1.61c-2.06,1-4.13,2-6.2,3.01c-2.07,1-4.15,2-6.22,3.02c-9.64,4.68-19.15,9.33-27.72,13.55 c-1.14,0.59-2.28,1.14-3.39,1.69c-1.33,0.66-2.63,1.3-3.91,1.94c-2.21,1.11-4.34,2.18-6.36,3.18c-1.05,0.54-2.07,1.04-3.04,1.54 c-0.81,0.41-1.61,0.83-2.39,1.21c-1.69,0.86-3.27,1.68-4.74,2.44c-0.45,0.24-0.88,0.47-1.31,0.69c-2.16,1.11-4.01,2.11-5.53,2.94 c-24.11,13.26-26.53-6.03-26.53-6.03c-0.95-3.44-1.83-6.91-2.64-10.4l132.93-52.45c1.31-0.52,2.79,0.14,3.27,1.47 C146.46,182.59,148.58,188.29,150.29,191.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 659.621,
    y1: 147.7955,
    x2: 600.6053,
    y2: 189.2776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M693.38,176c-17.37,15.07-40.41,30.64-60.18,32.47c-47.22,4.36-38.47-39.89-35.19-49.83 c1.57-4.77,1.4-8.09,0.33-10.37c-2.37-5.12-0.67-11.15,4.36-13.69c16.12-8.16,42.6-19.51,69.3-22.21c1.66,1.87,2.94,2.85,3.63,4.34 c1.07,2.28,1.24,5.6-0.33,10.37C672.48,135.59,665.67,169.22,693.38,176z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M817.56,264.92c-14.09,12.65-32.04,23.5-54.55,28.52c-28.57,6.34-58.59,7.85-82.23,3.94 c-46.16-7.62-77.12-51.38-66.31-90.23c4.96,1.47,11.13,2.04,18.73,1.33c10.13-0.93,21.1-5.48,31.75-11.72 c0.02,0,0.03-0.02,0.05-0.02c1.62-0.66,46.35-18.73,57.64-28.36c0.6-0.52,1.19-1.02,1.75-1.54c26.98,4.7,53.65,13.58,73.4,22.07 C832.75,203.93,845.85,239.5,817.56,264.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.1989,
    y1: 116.6854,
    x2: 669.1793,
    y2: 156.9591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#D3C6C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8BFC9"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M716.93,152.15c-4.3,5.51-12.86,14.59-23.56,23.85c-27.7-6.77-20.9-40.41-18.08-48.91 c1.57-4.77,1.4-8.09,0.33-10.37c-0.69-1.49-1.97-2.47-3.63-4.34c0.85-0.09,1.71-0.17,2.58-0.24c6.97-0.55,13.91-0.48,20.69,0.4 c0,0,9.06,0.78,18.54,6.72c0.05,0.03,0.12,0.07,0.17,0.1C723.19,125.24,726.37,140.05,716.93,152.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 825.4822,
    y1: 67.5521,
    x2: 824.5625,
    y2: 38.8104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M843.45,78.45c-3.16-4.27-7.69-6.55-11.94-5.48c-0.64,0.16-1.24,0.4-1.83,0.69 c-1.92,0.97-3.47,2.66-4.56,4.79c-0.54,1.07-0.97,2.26-1.26,3.53c-6.33-0.95-12.83-3.7-17.98-8.77 c-3.99-3.92-3.41-10.58,1.27-13.63c8.41-5.47,22.9-11.18,35.94,2.04C850,68.6,848.7,74.7,843.45,78.45z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M138.59,197.38c0.67-0.31,1.33-0.64,1.99-0.95c-1.09,0.54-2.21,1.07-3.34,1.61 C137.69,197.81,138.14,197.59,138.59,197.38z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M148.72,192.54c0.54-0.26,1.05-0.5,1.57-0.74c-1.3,0.62-2.63,1.24-3.99,1.9 C147.13,193.3,147.93,192.92,148.72,192.54z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M942.18,209.37c-3.53,12.56-8.3,26.29-15.23,40.27c-12.93,26.11-33.36,53.18-67.25,75.58 c-72.92,48.2-215.16,14.98-268.2-6.72c-53.02-21.69-133.79-105.46-162.11-105.46c-24.46,0-198.88-23.35-246.16-29.74 c-5.84-0.78-11.74-0.28-17.32,1.49c-1.78,0.55-3.54,1.24-5.25,2.06c-2.97,1.42-6.46,3.09-10.37,4.96 c-1.24-2.56-2.35-5.08-3.32-7.57c17.16-6.62,30.88-10.84,59.28-6.65c28.02,4.11,234.18,22.97,234.18,22.97 s137.14,77.74,158.19,84.79C619.7,292.4,714.46,328,778.7,313.88c63.84-14.02,121.57-24.23,152.28-103.66 C934.86,210.56,938.66,210.29,942.18,209.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.4749,
    y1: 58.1253,
    x2: 670.1731,
    y2: -17.7127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4689,
    style: {
      stopColor: "#8D949D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M852.9,34.66c-13.19,6.43-48.27,15.07-105.56-1.41c-153.5-44.16-299.04,1.94-284.35-6.01 c39.65-10.96,92.31-26.88,163-27.24c97.99-0.52,219.75,32.35,219.75,32.35C847.99,32.96,850.38,33.73,852.9,34.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 908.133,
    y1: 110.8649,
    x2: 932.2021,
    y2: 146.7991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#172029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M951.98,144.13c-14.1,11.86-28.45,13.62-43.09,9.99c-3.92-7.78-3.73-14.14-1.76-19.13 c4.03-10.13,15.61-15.02,25.92-11.51c4.72,1.61,10.49,3.85,16.28,6.79c-1.45,0.62-3.2,1.11-5.25,1.26 c-0.78,0.05-1.62,0.07-2.51,0.02C932.28,131.06,951.69,139.57,951.98,144.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.9646,
    y1: 126.8316,
    x2: 243.6049,
    y2: 170.4748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4689,
    style: {
      stopColor: "#8D949D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M329.64,139.19c-60.56,9.76-123.49,16.64-166.33,15.87c0.36-0.59,0.8-1.23,1.3-1.9 c4.93-6.62,57.2-24.62,116.97-27.69C319.93,123.49,329.35,129.87,329.64,139.19z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M293.85,126.52c1.44,5.81-1.57,11.56-6.73,12.84c-5.16,1.28-10.51-2.39-11.96-8.2 c-1.44-5.81,2.37-9.34,7.53-10.62C287.85,119.26,292.41,120.71,293.85,126.52z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M216.46,134.83c-0.03,4.76-2.34,8.6-5.16,8.58s-5.08-3.89-5.04-8.65c0.03-4.76,2.46-6.73,5.28-6.72 C214.35,128.06,216.49,130.07,216.46,134.83z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M185.6,146.72c1.39-2.19,1.05-4.91-0.77-6.07c-1.82-1.16-4.43-0.32-5.82,1.88c-1.39,2.19-0.42,4.1,1.4,5.26 C182.23,148.95,184.21,148.91,185.6,146.72z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult9);
export default __webpack_public_path__ + "static/media/fish-result-9.80df9185fb6d92d5878769737f956100.svg";
export { ForwardRef as ReactComponent };